import React from 'react';

const WelcomeSection = () => {
  return (
    <section className="w-full bg-gradient-to-br from-blue-100 via-white to-blue-100 py-16">
      <div className="w-full px-6 lg:px-12">
        {/* Main Container */}
        <div className="max-w-7xl mx-auto">
          
          {/* Decorative Top Element - Blue & Yellow Only */}
          <div className="flex justify-center mb-6">
            <div className="flex gap-2">
              <div className="w-12 h-1 bg-yellow-400 rounded-full"></div>
              <div className="w-8 h-1 bg-blue-500 rounded-full"></div>
              <div className="w-4 h-1 bg-yellow-500 rounded-full"></div>
            </div>
          </div>

          {/* Heading Section */}
          <div className="text-center mb-10">
            <div className="relative inline-block">
              <h2 className="text-4xl md:text-5xl font-bold relative z-10">
                <span className="bg-gradient-to-r from-yellow-500 via-yellow-600 to-blue-700 bg-clip-text text-transparent">
                  Welcome To BNS Mahila Maha Vidyalaya
                </span>
              </h2>
              <div className="absolute -bottom-3 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-yellow-500 to-blue-600 rounded-full"></div>
              <div className="absolute -bottom-5 left-1/4 right-1/4 h-1 bg-gradient-to-r from-yellow-300 via-yellow-400 to-blue-400 rounded-full opacity-60"></div>
            </div>
            <p className="text-blue-700 text-sm md:text-base mt-6 font-medium tracking-wide">
              Empowering Students Through Quality Higher Education Since 2000+
            </p>
          </div>

          {/* Two Cards Layout - Left and Right */}
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
            
            {/* Left Card */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
              {/* Card Header with Blue & Yellow Gradient */}
              <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-blue-600 p-4">
                <h3 className="text-white font-bold text-xl text-center">About Our College</h3>
              </div>
              
              {/* Card Body */}
              <div className="p-6 space-y-4">
                <p className="text-gray-700 text-sm leading-relaxed">
                  Welcome to <span className="font-bold text-blue-700">BNS Mahila Maha Vidyalaya</span>, a distinguished institution dedicated to empowering students through quality higher education. Affiliated with <span className="font-bold text-yellow-600">Mahatma Gandhi Kashi Vidyapith (MGKVP)</span>, our college provides an academically enriching environment that nurtures intellectual growth and holistic development.
                </p>
                
                <p className="text-gray-700 text-sm leading-relaxed">
                  At BNS Mahila Maha Vidyalaya, we offer undergraduate programs in 
                  <span className="font-bold text-blue-700 mx-1">Bachelor of Arts (B.A.)</span> 
                  and 
                  <span className="font-bold text-blue-700 mx-1">Bachelor of Science (B.Sc.)</span>, 
                  equipping students with the knowledge, skills, and confidence to excel in their chosen fields.
                </p>
                
                <p className="text-gray-700 text-sm leading-relaxed">
                  Our institution is committed to fostering a culture of academic excellence, innovation, and ethical values. With a team of experienced faculty, state-of-the-art facilities, and a student-centric approach, we strive to shape the leaders of tomorrow.
                </p>
                
                <div className="bg-gradient-to-r from-yellow-50 to-blue-50 rounded-xl p-4 mt-3">
                  <p className="text-blue-800 font-semibold text-sm text-center">
                     Join us on a journey of knowledge and transformation at BNS Mahila Maha Vidyalaya! 
                  </p>
                </div>

                {/* Key Highlights */}
                <div className="grid grid-cols-2 gap-2 pt-2">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                    <span className="text-xs text-gray-700">Affiliated with MGKVP</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    <span className="text-xs text-gray-700">B.A. & B.Sc. Programs</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-yellow-600 rounded-full"></div>
                    <span className="text-xs text-gray-700">Experienced Faculty</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                    <span className="text-xs text-gray-700">Student-Centric Approach</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Card */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
              {/* Card Header with Blue & Yellow Gradient (reversed) */}
              <div className="bg-gradient-to-r from-blue-600 via-yellow-500 to-yellow-400 p-4">
                <h3 className="text-white font-bold text-xl text-center">Why Choose Us?</h3>
              </div>
              
              {/* Card Body */}
              <div className="p-6 space-y-5">
                {/* Stats Section */}
                <div className="space-y-3">
                  <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                    <span className="text-sm font-medium text-gray-600">Years of Excellence</span>
                    <span className="font-bold text-yellow-600 text-lg">Since 2000+</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                    <span className="text-sm font-medium text-gray-600">Qualified Faculty</span>
                    <span className="font-bold text-yellow-600 text-lg">30+</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                    <span className="text-sm font-medium text-gray-600">Student Enrollment</span>
                    <span className="font-bold text-yellow-600 text-lg">1000+</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm font-medium text-gray-600">Programs Offered</span>
                    <span className="font-bold text-blue-600 text-lg">B.A. & B.Sc.</span>
                  </div>
                </div>

                {/* Mission & Vision Combined */}
                <div className="space-y-4 pt-3">
                  <div className="bg-gradient-to-r from-yellow-50 to-blue-50 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center text-white font-bold text-sm">
                        M
                      </div>
                      <div>
                        <h4 className="font-bold text-yellow-700 text-sm mb-1">Our Mission</h4>
                        <p className="text-gray-700 text-xs leading-relaxed">
                          To empower women through quality education, fostering academic excellence, 
                          ethical values, and holistic development for a brighter future.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-blue-50 to-yellow-50 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-sm">
                        V
                      </div>
                      <div>
                        <h4 className="font-bold text-blue-800 text-sm mb-1">Our Vision</h4>
                        <p className="text-gray-700 text-xs leading-relaxed">
                          To be a premier institution nurturing empowered, confident, and socially 
                          responsible women leaders contributing to national development.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Decorative Element - Blue & Yellow Only */}
          <div className="mt-12 flex justify-center">
            <div className="flex gap-2">
              <div className="w-4 h-1 bg-blue-600 rounded-full"></div>
              <div className="w-8 h-1 bg-yellow-500 rounded-full"></div>
              <div className="w-12 h-1 bg-yellow-400 rounded-full"></div>
              <div className="w-8 h-1 bg-blue-500 rounded-full"></div>
              <div className="w-4 h-1 bg-blue-600 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;